import { useMutation } from "urql";

import { InviteUserDocument } from "../../../graphql/generated.ts";

export function useInviteUser() {
  return useMutation(InviteUserDocument);
}
